'use client';

import { Text } from '@smartproxy/decoro/v2/text';

import { cn } from '@/lib/utils';

import { NextImageProps } from '@/components/atoms/Image';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import { Marquee } from '@/components/marquee/Marquee';

import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { BentoImageCarouselItem } from '.';

export type BentoImageCarouselStrapiProps = {
  title?: string;
  images: ImageStrapiProps[];
};

export function BentoImageCarouselStrapi({
  block,
  inner,
}: BlockComponentModel<
  BentoImageCarouselStrapiProps,
  {
    imageProps?: NextImageProps;
  }
>) {
  const { title, images } = block;

  return (
    <BlockWrapper
      contentFit='full'
      classNames={{
        root: cn(
          'bg-gray-dark-950 border-y border-gray-dark-700',
          '!px-5 !pt-8 !pb-5 md:!p-10'
        ),
      }}
      data-tracker-section={SECTION_NAMES.BENTO_IMAGE_CAROUSEL}
    >
      <div className='flex w-full flex-col'>
        {title ? (
          <Text
            variant='body_s'
            skin='light'
            className='pb-6 text-center md:pb-8'
          >
            {title}
          </Text>
        ) : null}
        <Marquee
          data-tracker-section={SECTION_NAMES.BENTO_IMAGE_CAROUSEL}
          repeat={4}
          syncSeamWithItemGap
          config={{ duration: 45 }}
          classNames={{
            inner:
              'w-auto justify-start gap-8 md:w-full md:justify-between md:gap-0',
          }}
        >
          {images?.map((img, i) => (
            <BentoImageCarouselItem
              key={i}
              logo={
                <ImageStrapi
                  block={img}
                  inner={{
                    classNames: {
                      ...inner?.imageProps?.classNames,
                      image: cn(
                        'h-4 w-auto brightness-0 invert opacity-90',
                        inner?.imageProps?.classNames?.image
                      ),
                    },
                  }}
                />
              }
            />
          ))}
        </Marquee>
      </div>
    </BlockWrapper>
  );
}
